import { render, staticRenderFns } from "./Pagination.html?vue&type=template&id=7ae65b9b&scoped=true&"
import script from "./Pagination.js?vue&type=script&lang=js&"
export * from "./Pagination.js?vue&type=script&lang=js&"
import style0 from "./Pagination.scss?vue&type=style&index=0&id=7ae65b9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae65b9b",
  null
  
)

export default component.exports